import { type } from '@/utils/type'

export const MISSION_REQUEST = type('MISSION_REQUEST')
export const MISSION_SUCCESS = type('MISSION_SUCCESS')
export const MISSION_PASSED_SUCCESS = type('MISSION_PASSED_SUCCESS')
export const MISSION_PASSED_PRELOAD_SUCCESS = type('MISSION_PASSED_PRELOAD_SUCCESS')
export const MISSION_ERROR = type('MISSION_ERROR')

export const MISSION_LOADING_REQUEST = type('MISSION_LOADING_REQUEST')
export const MISSION_LOADING_SUCCESS = type('MISSION_LOADING_SUCCESS')
export const MISSION_LOADING_ERROR = type('MISSION_LOADING_ERROR')

export const MISSION_LOADING_SCIVARIABLE_REQUEST = type('MISSION_LOADING_SCIVARIABLE_REQUEST')
export const MISSION_LOADING_SCIVARIABLE_SUCCESS = type('MISSION_LOADING_SCIVARIABLE_SUCCESS')
export const MISSION_LOADING_SCIVARIABLE_ERROR = type('MISSION_LOADING_SCIVARIABLE_ERROR')

export const MISSION_DATA_SCIENCE_REQUEST = type('MISSION_DATA_SCIENCE_REQUEST')
export const MISSION_DATA_SCIENCE_SUCCESS = type('MISSION_DATA_SCIENCE_SUCCESS')
export const MISSION_DATA_SCIENCE_ERROR = type('MISSION_DATA_SCIENCE_ERROR')

export const MISSION_DATA_NAVIGATION_REQUEST = type('MISSION_DATA_NAVIGATION_REQUEST')
export const MISSION_DATA_NAVIGATION_SUCCESS = type('MISSION_DATA_NAVIGATION_SUCCESS')
export const MISSION_DATA_NAVIGATION_ERROR = type('MISSION_DATA_NAVIGATION_ERROR')

export const MISSION_DATA_NMEA_REQUEST = type('MISSION_DATA_NMEA_REQUEST')
export const MISSION_DATA_NMEA_SUCCESS = type('MISSION_DATA_NMEA_SUCCESS')
export const MISSION_DATA_NMEA_ERROR = type('MISSION_DATA_NMEA_ERROR')

export const MISSION_DRIFT_REQUEST = type('MISSION_DRIFT_REQUEST')
export const MISSION_DRIFT_SUCCESS = type('MISSION_DRIFT_SUCCESS')
export const MISSION_DRIFT_ERROR = type('MISSION_DRIFT_ERROR')

export const MISSION_UNSELECT = type('MISSION_UNSELECT')

export const MISSION_DELETE = type('MISSION_DELETE')

export const MISSION_SELECT_DETAIL_REQUEST = type('MISSION_SELECT_DETAIL_REQUEST')
export const MISSION_SELECT_DETAIL_SUCCESS = type('MISSION_SELECT_DETAIL_SUCCESS')
export const MISSION_SELECT_DETAIL_ERROR = type('MISSION_SELECT_DETAIL_ERROR')
export const MISSION_SELECT_DETAIL = type('MISSION_SELECT_DETAIL')
export const MISSION_SET_LEFTPANEL_SIZE = type('MISSION_SET_LEFTPANEL_SIZE')

export const MISSION_UNSELECT_DETAIL = type('MISSION_UNSELECT_DETAIL')
export const MISSION_NAVTO_DETAIL = type('MISSION_NAVTO_DETAIL')
export const MISSION_UNSELECT_TAB = type('MISSION_UNSELECT_TAB')
export const MISSION_CLOSE_TAB = type('MISSION_CLOSE_TAB')
export const MISSION_MOVE_TAB = type('MISSION_MOVE_TAB')
export const MISSION_RENAME_DETAIL = type('MISSION_RENAME_DETAIL')

export const MISSION_SAVE_IMAGE_REQUEST = type('MISSION_SAVE_IMAGE_REQUEST')
export const MISSION_SAVE_IMAGE_SUCCESS = type('MISSION_SAVE_IMAGE_SUCCESS')
export const MISSION_SAVE_IMAGE_ERROR = type('MISSION_SAVE_IMAGE_ERROR')

export const MISSION_SET_GLIDER_FILTER = type('MISSION_SET_GLIDER_FILTER')
export const MISSION_SET_ENSEIGNE_FILTER = type('MISSION_SET_ENSEIGNE_FILTER')
export const MISSION_SET_ALARM_FILTER = type('MISSION_SET_ALARM_FILTER')
export const MISSION_SET_ONGOING_FILTER = type('MISSION_SET_ONGOING_FILTER')
export const MISSION_SET_SIMULATED_FILTER = type('MISSION_SET_SIMULATED_FILTER')
export const MISSION_RESET_FILTER = type('MISSION_RESET_FILTER')

export const MISSION_ADD_CONSOLE_ROW = type('MISSION_ADD_CONSOLE_ROW')
export const MISSION_CLEAR_CONSOLE = type('MISSION_CLEAR_CONSOLE')
export const MISSION_ENSURE_MISSION = type('MISSION_ENSURE_MISSION')
export const MISSION_ENSURE_DATA_NMEA = type('MISSION_ENSURE_DATA_NMEA')
export const MISSION_ENSURE_DATA_SCIENCE = type('MISSION_ENSURE_DATA_SCIENCE')
export const MISSION_ENSURE_DATA_NAVIGATION = type('MISSION_ENSURE_DATA_NAVIGATION')
export const MISSION_ENSURE_DRIFT = type('MISSION_ENSURE_DRIFT')
export const MISSION_UPDATE = type('MISSION_UPDATE')
export const MISSION_UPDATE_NMEA = type('MISSION_UPDATE_NMEA')
export const MISSION_UPDATE_DOWNLOAD_FILE_STATUS = type('MISSION_UPDATE_DOWNLOAD_FILE_STATUS')

export const MISSION_ENSURE_FILETRANSFERT_STATE = type('MISSION_ENSURE_FILETRANSFERT_STATE')
export const MISSION_ENSURE_DOWNLOAD_FILE_STATUS = type('MISSION_ENSURE_DOWNLOAD_FILE_STATUS')

export const MISSION_DOWNLOAD_FILE_STATUS_REQUEST = type('MISSION_DOWNLOAD_FILE_STATUS_REQUEST')
export const MISSION_DOWNLOAD_FILE_STATUS_SUCCESS = type('MISSION_DOWNLOAD_FILE_STATUS_SUCCESS')
export const MISSION_DOWNLOAD_FILE_STATUS_ERROR = type('MISSION_DOWNLOAD_FILE_STATUS_ERROR')

export const MISSION_ENDMISSION_UPDATE_PROGRESSION = type('MISSION_ENDMISSION_UPDATE_PROGRESSION')

export const MISSION_END = type('MISSION_END')

export const MISSION_LOGBOOK_REQUEST = type('MISSION_LOGBOOK_REQUEST')
export const MISSION_LOGBOOK_SUCCESS = type('MISSION_LOGBOOK_SUCCESS')
export const MISSION_LOGBOOK_ERROR = type('MISSION_LOGBOOK_ERROR')
export const MISSION_LOGBOOK_ITEM_REQUEST = type('MISSION_LOGBOOK_ITEM_REQUEST')
export const MISSION_LOGBOOK_ITEM_SUCCESS = type('MISSION_LOGBOOK_ITEM_SUCCESS')
export const MISSION_LOGBOOK_ITEM_ERROR = type('MISSION_LOGBOOK_ITEM_ERROR')
export const MISSION_LOGBOOK_SEND_MESSAGE_REQUEST = type('MISSION_LOGBOOK_SEND_MESSAGE_REQUEST')
export const MISSION_LOGBOOK_SEND_MESSAGE_ERROR = type('MISSION_LOGBOOK_SEND_MESSAGE_ERROR')

export const MISSION_LOGBOOK_UPDATE_MESSAGE_REQUEST = type('MISSION_LOGBOOK_UPDATE_MESSAGE_REQUEST')
export const MISSION_LOGBOOK_UPDATE_MESSAGE_ERROR = type('MISSION_LOGBOOK_UPDATE_MESSAGE_ERROR')

export const MISSION_IRIS_SEND_MAIL_REQUEST = type('MISSION_IRIS_SEND_MAIL_REQUEST')
export const MISSION_IRIS_SEND_MAIL_SUCCESS = type('MISSION_IRIS_SEND_MAIL_SUCCESS')
export const MISSION_IRIS_SEND_MAIL_ERROR = type('MISSION_IRIS_SEND_MAIL_ERROR')

export const MISSION_UPDATE_MODIFIED_SEND_MAIL = type('MISSION_UPDATE_MODIFIED_SEND_MAIL')
export const MISSION_CANCEL_MODIFIED_SEND_MAIL = type('MISSION_CANCEL_MODIFIED_SEND_MAIL')

export const MISSION_IRIS_SEND_MAIL_SAVE_REQUEST = type('MISSION_IRIS_SEND_MAIL_SAVE_REQUEST')
export const MISSION_IRIS_SEND_MAIL_SAVE_SUCCESS = type('MISSION_IRIS_SEND_MAIL_SAVE_SUCCESS')
export const MISSION_IRIS_SEND_MAIL_SAVE_ERROR = type('MISSION_IRIS_SEND_MAIL_SAVE_ERROR')
export const MISSION_IRIS_SEND_MAIL_ENABLE_REQUEST = type('MISSION_IRIS_SEND_MAIL_ENABLE_REQUEST')

export const MISSION_LBK_ALERT_SAVE_REQUEST = type('MISSION_LBK_ALERT_SAVE_REQUEST')
export const MISSION_LBK_ALERT_SAVE_SUCCESS = type('MISSION_LBK_ALERT_SAVE_SUCCESS')
export const MISSION_LBK_ALERT_SAVE_ERROR = type('MISSION_LBK_ALERT_SAVE_ERROR')

export const MISSION_ENSURE_MISSION_PLAN = type('MISSION_ENSURE_MISSION_PLAN')
export const MISSION_PLAN_REQUEST = type('MISSION_PLAN_REQUEST')
export const MISSION_PLAN_SUCCESS = type('MISSION_PLAN_SUCCESS')
export const MISSION_PLAN_ERROR = type('MISSION_PLAN_ERROR')

export const MISSION_PLAN_SAVE_REQUEST = type('MISSION_PLAN_SAVE_REQUEST')
export const MISSION_PLAN_SAVE_SUCCESS = type('MISSION_PLAN_SAVE_SUCCESS')
export const MISSION_PLAN_SAVE_ERROR = type('MISSION_PLAN_SAVE_ERROR')

export const MISSION_PLAN_PUBLISH_REQUEST = type('MISSION_PLAN_PUBLISH_REQUEST')
export const MISSION_PLAN_PUBLISH_SUCCESS = type('MISSION_PLAN_PUBLISH_SUCCESS')
export const MISSION_PLAN_PUBLISH_ERROR = type('MISSION_PLAN_PUBLISH_ERROR')

export const MISSION_PLAN_POPULATE_FROM_TEMPLATE_REQUEST = type('MISSION_PLAN_POPULATE_FROM_TEMPLATE_REQUEST')
export const MISSION_PLAN_POPULATE_FROM_TEMPLATE_SUCCESS = type('MISSION_PLAN_POPULATE_FROM_TEMPLATE_SUCCESS')
export const MISSION_PLAN_POPULATE_FROM_TEMPLATE_ERROR = type('MISSION_PLAN_POPULATE_FROM_TEMPLATE_ERROR')

export const MISSION_IRIS_MISSION_PLAN_REQUEST = type('MISSION_IRIS_MISSION_PLAN_REQUEST')
export const MISSION_IRIS_MISSION_PLAN_SUCCESS = type('MISSION_IRIS_MISSION_PLAN_SUCCESS')
export const MISSION_IRIS_MISSION_PLAN_ERROR = type('MISSION_IRIS_MISSION_PLAN_ERROR')

export const MISSION_IRIS_MISSION_PLAN_CONFIG_REQUEST = type('MISSION_IRIS_MISSION_PLAN_CONFIG_REQUEST')
export const MISSION_IRIS_MISSION_PLAN_CONFIG_SUCCESS = type('MISSION_IRIS_MISSION_PLAN_CONFIG_SUCCESS')
export const MISSION_IRIS_MISSION_PLAN_CONFIG_ERROR = type('MISSION_IRIS_MISSION_PLAN_CONFIG_ERROR')

export const MISSION_IRIS_MISSION_PLAN_CONFIG_SAVE_REQUEST = type('MISSION_IRIS_MISSION_PLAN_CONFIG_SAVE_REQUEST')
export const MISSION_IRIS_MISSION_PLAN_CONFIG_SAVE_SUCCESS = type('MISSION_IRIS_MISSION_PLAN_CONFIG_SAVE_SUCCESS')
export const MISSION_IRIS_MISSION_PLAN_CONFIG_SAVE_ERROR = type('MISSION_IRIS_MISSION_PLAN_CONFIG_SAVE_ERROR')
export const MISSION_IRIS_MISSION_PLAN_CONFIG_ENABLE_REQUEST = type('MISSION_IRIS_MISSION_PLAN_CONFIG_ENABLE_REQUEST')

export const MISSION_UPDATE_MODIFIED_MISSION_PLAN_CONFIG = type('MISSION_UPDATE_MODIFIED_MISSION_PLAN_CONFIG')
export const MISSION_CANCEL_MODIFIED_MISSION_PLAN_CONFIG = type('MISSION_CANCEL_MODIFIED_MISSION_PLAN_CONFIG')

export const MISSION_IRIS_GLIDER_STATE_REQUEST = type('MISSION_IRIS_GLIDER_STATE_REQUEST')
export const MISSION_IRIS_GLIDER_STATE_SUCCESS = type('MISSION_IRIS_GLIDER_STATE_SUCCESS')
export const MISSION_IRIS_GLIDER_STATE_ERROR = type('MISSION_IRIS_GLIDER_STATE_ERROR')
/** Patch ciblé d'un module enable dans gliderRuntime.modules — déclenché par
 *  chaque success de fetch IRIS module config et par WobGliderModConf WS. */
export const GLIDER_RUNTIME_PATCH_MODULE_ENABLE = type('GLIDER_RUNTIME_PATCH_MODULE_ENABLE')
/** Patch temps réel de gliderRuntime.alarmCode — déclenché par WobGliderAlarm WS
 *  (flags non-acquittés bloc 1 convertis en bitmap). */
export const GLIDER_RUNTIME_PATCH_ALARM = type('GLIDER_RUNTIME_PATCH_ALARM')

export const MISSION_IRIS_AD2CP_REQUEST = type('MISSION_IRIS_AD2CP_REQUEST')
export const MISSION_IRIS_AD2CP_SUCCESS = type('MISSION_IRIS_AD2CP_SUCCESS')
export const MISSION_IRIS_AD2CP_ERROR = type('MISSION_IRIS_AD2CP_ERROR')

export const MISSION_UPDATE_MODIFIED_AD2CP = type('MISSION_UPDATE_MODIFIED_AD2CP')
export const MISSION_CANCEL_MODIFIED_AD2CP = type('MISSION_CANCEL_MODIFIED_AD2CP')

export const MISSION_IRIS_AD2CP_SAVE_REQUEST = type('MISSION_IRIS_AD2CP_SAVE_REQUEST')
export const MISSION_IRIS_AD2CP_SAVE_SUCCESS = type('MISSION_IRIS_AD2CP_SAVE_SUCCESS')
export const MISSION_IRIS_AD2CP_SAVE_ERROR = type('MISSION_IRIS_AD2CP_SAVE_ERROR')
export const MISSION_IRIS_AD2CP_ENABLE_REQUEST = type('MISSION_IRIS_AD2CP_ENABLE_REQUEST')

export const MISSION_IRIS_AD2CP_RUN_REQUEST = type('MISSION_IRIS_AD2CP_RUN_REQUEST')
export const MISSION_IRIS_AD2CP_RUN_SUCCESS = type('MISSION_IRIS_AD2CP_RUN_SUCCESS')
export const MISSION_IRIS_AD2CP_RUN_ERROR = type('MISSION_IRIS_AD2CP_RUN_ERROR')

export const MISSION_IRIS_CORIOLIS_REQUEST = type('MISSION_IRIS_CORIOLIS_REQUEST')
export const MISSION_IRIS_CORIOLIS_SUCCESS = type('MISSION_IRIS_CORIOLIS_SUCCESS')
export const MISSION_IRIS_CORIOLIS_ERROR = type('MISSION_IRIS_CORIOLIS_ERROR')

export const MISSION_UPDATE_MODIFIED_CORIOLIS = type('MISSION_UPDATE_MODIFIED_CORIOLIS')
export const MISSION_CANCEL_MODIFIED_CORIOLIS = type('MISSION_CANCEL_MODIFIED_CORIOLIS')

export const MISSION_IRIS_CORIOLIS_SAVE_REQUEST = type('MISSION_IRIS_CORIOLIS_SAVE_REQUEST')
export const MISSION_IRIS_CORIOLIS_SAVE_SUCCESS = type('MISSION_IRIS_CORIOLIS_SAVE_SUCCESS')
export const MISSION_IRIS_CORIOLIS_SAVE_ERROR = type('MISSION_IRIS_CORIOLIS_SAVE_ERROR')
export const MISSION_IRIS_CORIOLIS_ENABLE_REQUEST = type('MISSION_IRIS_CORIOLIS_ENABLE_REQUEST')

export const MISSION_IRIS_CORIOLIS_RUN_REQUEST = type('MISSION_IRIS_CORIOLIS_RUN_REQUEST')
export const MISSION_IRIS_CORIOLIS_RUN_SUCCESS = type('MISSION_IRIS_CORIOLIS_RUN_SUCCESS')
export const MISSION_IRIS_CORIOLIS_RUN_ERROR = type('MISSION_IRIS_CORIOLIS_RUN_ERROR')

export const MISSION_IRIS_AIS_REQUEST = type('MISSION_IRIS_AIS_REQUEST')
export const MISSION_IRIS_AIS_SUCCESS = type('MISSION_IRIS_AIS_SUCCESS')
export const MISSION_IRIS_AIS_ERROR = type('MISSION_IRIS_AIS_ERROR')

export const MISSION_UPDATE_MODIFIED_AIS = type('MISSION_UPDATE_MODIFIED_AIS')
export const MISSION_CANCEL_MODIFIED_AIS = type('MISSION_CANCEL_MODIFIED_AIS')

export const MISSION_IRIS_AIS_SAVE_REQUEST = type('MISSION_IRIS_AIS_SAVE_REQUEST')
export const MISSION_IRIS_AIS_SAVE_SUCCESS = type('MISSION_IRIS_AIS_SAVE_SUCCESS')
export const MISSION_IRIS_AIS_SAVE_ERROR = type('MISSION_IRIS_AIS_SAVE_ERROR')
export const MISSION_IRIS_AIS_ENABLE_REQUEST = type('MISSION_IRIS_AIS_ENABLE_REQUEST')

export const MISSION_IRIS_AIS_STATUS_UPDATE = type('MISSION_IRIS_AIS_STATUS_UPDATE')

export const MISSION_IRIS_ENCRYPTION_GET_REQUEST = type('MISSION_IRIS_ENCRYPTION_GET_REQUEST')
export const MISSION_IRIS_ENCRYPTION_GET_SUCCESS = type('MISSION_IRIS_ENCRYPTION_GET_SUCCESS')
export const MISSION_IRIS_ENCRYPTION_GET_ERROR = type('MISSION_IRIS_ENCRYPTION_GET_ERROR')
export const MISSION_IRIS_ENCRYPTION_SAVE_REQUEST = type('MISSION_IRIS_ENCRYPTION_SAVE_REQUEST')
export const MISSION_IRIS_ENCRYPTION_SAVE_SUCCESS = type('MISSION_IRIS_ENCRYPTION_SAVE_SUCCESS')
export const MISSION_IRIS_ENCRYPTION_SAVE_ERROR = type('MISSION_IRIS_ENCRYPTION_SAVE_ERROR')

export const MISSION_IRIS_QUICKCONTROL_CONFIG_REQUEST = type('MISSION_IRIS_QUICKCONTROL_CONFIG_REQUEST')
export const MISSION_IRIS_QUICKCONTROL_CONFIG_SUCCESS = type('MISSION_IRIS_QUICKCONTROL_CONFIG_SUCCESS')
export const MISSION_IRIS_QUICKCONTROL_CONFIG_ERROR = type('MISSION_IRIS_QUICKCONTROL_CONFIG_ERROR')

export const MISSION_IRIS_QUICKCONTROL_CONFIG_SAVE_REQUEST = type('MISSION_IRIS_QUICKCONTROL_CONFIG_SAVE_REQUEST')
export const MISSION_IRIS_QUICKCONTROL_CONFIG_SAVE_SUCCESS = type('MISSION_IRIS_QUICKCONTROL_CONFIG_SAVE_SUCCESS')
export const MISSION_IRIS_QUICKCONTROL_CONFIG_SAVE_ERROR = type('MISSION_IRIS_QUICKCONTROL_CONFIG_SAVE_ERROR')

export const MISSION_UPDATE_MODIFIED_QUICKCONTROL_CONFIG = type('MISSION_UPDATE_MODIFIED_QUICKCONTROL_CONFIG')
export const MISSION_CANCEL_MODIFIED_QUICKCONTROL = type('MISSION_CANCEL_MODIFIED_QUICKCONTROL')

export const MISSION_RUN_END_SIMULATION_REQUEST = type('MISSION_RUN_END_SIMULATION_REQUEST')
export const MISSION_RUN_END_SIMULATION_SUCCESS = type('MISSION_RUN_END_SIMULATION_SUCCESS')
export const MISSION_RUN_END_SIMULATION_ERROR = type('MISSION_RUN_END_SIMULATION_ERROR')
